<template>
  <div>
    <p class="cm-mg-p-wzd text-center text-muted">
      2. {{ $t('common_words.verify_inputed_information') }}
    </p>
    <div class="row d-flex justify-content-center">
      <div class="col-10">
        <table class="table">
          <tbody>
            <tr class="shadow-sm">
              <td>
                <strong>{{ $t('common_words.company') }}:</strong>
                {{ infoData.business_name || '-' }}
              </td>
              <td>
                <strong>{{ $t('common_words.farm') }}:</strong>
                {{ infoData.farm_name || '-' }}
              </td>
            </tr>
          </tbody>
        </table>

        <div
          v-for="(_, index) in infoData.names"
          :key="`crew-confirm-${index}`"
          class="row border rounded-sm shadow-sm p-3 mb-3 align-items-center"
        >
          <div class="col-12 col-md-5">
            <strong>{{ $t('common_words.name') }}:</strong>
            <span class="ml-2">{{ infoData.names[index] }}</span>
          </div>
          <div class="col-12 col-md-7">
            <strong>{{ $t('labor.workers') }}:</strong>
            <div
              class="mt-1"
              v-if="
                infoData.worker_names &&
                infoData.worker_names[index] &&
                infoData.worker_names[index].length
              "
            >
              <span
                v-for="(wName, wIdx) in infoData.worker_names[index]"
                :key="wIdx"
                class="badge badge-success mr-1 mb-1"
              >
                {{ wName }}
              </span>
            </div>
            <span v-else class="text-muted font-italic ml-2">
              {{ $t('common_words.none') }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepConfirm',
  props: {
    infoData: {
      type: Object,
      required: true,
    },
  },
};
</script>
